import React from "react";
import DotLoader from "react-spinners/DotLoader";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};
const loading = {
  position: "absolute",
  width: "100%",
  textAlign: "center",
  zIndex: 1,
  maxWidth: "60px",
  top: "50vh",
  left: "50vw",
  transform: "translateX(-50%)",
};

class Loading extends React.Component {
  render() {
    const { className } = this.props;

    return (
      <div style={loading} className={className}>
        <DotLoader
          css={override}
          sizeUnit={"px"}
          size={60}
          color={"var(--primary-color)"}
          loading={this.props.isLoading}
        />
      </div>
    );
  }
}

export default Loading;
